import { render, staticRenderFns } from "./ActiveSubscriptionRequiredModal.vue?vue&type=template&id=4be79530&"
import script from "./ActiveSubscriptionRequiredModal.vue?vue&type=script&lang=js&"
export * from "./ActiveSubscriptionRequiredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports